﻿import AutoComplete from "@tarekraafat/autocomplete.js/src/autocomplete.js";
import { registerComponent } from "./component";
import { initPopupContainer, initPopup } from "./_menu";
import { createElement, onEvent, uniqueId } from "./_dom";


const htmlEncode = (() => {
	const _htmlEncMap = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' };
	const _htmlEncRE = /([&<>"])/g;
	return (value /*: string*/) => value.replace(_htmlEncRE, (_str, m) => _htmlEncMap[m]);
})();

/*
const htmlDecode = (() => {
	const _htmlDecMap = { '&amp;': '&', '&lt;': '<', '&gt;': '>', '&quot;': '"' };
	const _htmlDecRE = /(&amp;|&lt;|&gt;|&quot;)/g;
	return (value: string) => value.replace(_htmlDecRE, (_str, m) => _htmlDecMap[m])
})();
*/

/* matches all on empty query, otherwise query substring presence */
/* responsible for htmlEncoding the text */
function searchEngine(query, record) {
	function normalize(str /*: string*/) {
		return str
			.normalize("NFD")
			.replace(/[\u0300-\u036f]/g, "")
			.normalize("NFC");
	}
	const srecord = String(record);
	if (query) {
		query = normalize(query).toLocaleUpperCase();
		const value = normalize(srecord).toLocaleUpperCase();
		if (value.indexOf(query) < 0) {
			return;
		}
	}
	const match = htmlEncode(srecord);
	return match;
}

function createAutocomplete(field) {
	const dataList = JSON.parse(field.dataset.autocompleteList) /* as string[] */;
	const fieldId = uniqueId(field);
	const listId = `autoComplete_list_${fieldId}`;
	const autocompleteDropdown = new AutoComplete({
		selector: `#${fieldId}`,
		wrapper: false,
		threshold: 0,
		debounce: 300,
		data: { src: dataList },
		searchEngine, 
		resultsList: {
			id: listId,
			tag: "ul",
			class: "v3-menu v3-menu-scrollable v3-popup",
			destination: initPopupContainer,
			position: "beforeend"
		},
		resultItem: {
			element: (el) => {
				var subitems = [...el.childNodes];
				el.setAttribute("role", "none");
				el.replaceChildren(createElement("span", { class: "v3-menu__item", role: "option" }, ...subitems));
			},
			tag: "li",
			class: "v3-menu__cell",
			selected: "active"
		},
		events: {
			input: {
				selection: (event) => {
					const { value } = event.detail.selection;
					if (field.value != value) {
						field.value = value;
						field.dispatchEvent(new Event("change", { bubbles: true }));
					}
				}
			}
		}
	});
	field.addEventListener("open", () => {
		const list = document.getElementById(listId);
		initPopup(field, list);
		list.classList.add("show");
	});
	field.addEventListener("close", () => {
		const list = document.getElementById(listId);
		list.classList.remove("show");
		list["popperCleanup"]?.();
	});
	field.addEventListener("navigate", () => {
		const list = document.getElementById(listId);
		list.querySelectorAll(".v3-menu__item--active").forEach(item => item.classList.remove("v3-menu__item--active"));
		list.querySelector(".v3-menu__cell.active > .v3-menu__item")?.classList.add("v3-menu__item--active");
	});
	// open list on focusin
	field.addEventListener("focusin", (event) => {
		autocompleteDropdown.start();
	});
	// open list on init
	autocompleteDropdown.start();
}

const autocomplete = registerComponent(createAutocomplete);

function init(context, selector = "input[data-autocomplete-list]") {
	onEvent(context, selector, "focusin", (_event, input) => autocomplete(input));
}

export { init/*, autocomplete*/ };